/** Display tuning for the dashboard charts and stat cards (recharts props and card keys). */

/** Shared tooltip look for every dashboard chart. */
export const CHART_TOOLTIP_STYLE = {
  border: '1px solid #E4E4E7',
  borderRadius: 8,
  fontSize: 12,
  boxShadow: 'none',
} as const

// POI-per-destination bar chart
export const POI_CHART_HEIGHT = 240
export const CHART_BAR_COLOR = '#2563EB'
export const CHART_BAR_RADIUS: [number, number, number, number] = [4, 4, 0, 0]
export const CHART_BAR_MAX_SIZE = 60
export const CHART_CATEGORY_GAP = '30%'
export const CHART_AXIS_FONT_SIZE = 11
export const CHART_AXIS_COLOR = '#71717A'
/** Axis labels longer than this are cut with an ellipsis (the full text stays in the `<title>` tooltip). */
export const CHART_LABEL_MAX_LENGTH = 14

// POI status donut chart
export const STATUS_CHART_HEIGHT = 220
export const DONUT_INNER_RADIUS = 55
export const DONUT_OUTER_RADIUS = 80
export const DONUT_PADDING_ANGLE = 2
/** Slice colour per POI status key returned by the dashboard API. */
export const POI_STATUS_COLORS: Record<string, string> = {
  active: '#2563EB',
  inactive: '#A1A1AA',
}

/** Keys of the stat cards, used for the i18n label lookup and the card order. */
export const DASHBOARD_STAT_KEYS = {
  tenants: 'tenants',
  pois: 'pois',
  tours: 'tours',
  destinations: 'destinations',
  languages: 'languages',
} as const
